import { h } from 'preact'

import { TITLES } from '../../../../config'
import BackgroundTitle from '../../../atom/BackgroundTitle'
import GridList, { GridListEntry } from '../../../atom/GridList'
import { SiteContentEntry } from '../../SiteContent'
import { GenerateImageArticleCollection } from '../../../atom/ImageArticle'
import { buildClassNames } from '../classNames'
import { SIDE_LEFT } from '../../../../constants'

const ArticleRelated = (props) => {
  const { related = [], ...rest } = props

  const isBalanced = related.length % 3 !== 0

  return (
    <SiteContentEntry {...rest} noMargin>
      <header className={buildClassNames({
        offsetSide: SIDE_LEFT,
        marginBottom: true,
      })}>
        <BackgroundTitle
          level={2}
          noMargin
          small
        >
          {TITLES.RELATED}
        </BackgroundTitle>
      </header>

      <div className={buildClassNames()}>
        <GridList balanced={isBalanced}>
          {GenerateImageArticleCollection({
            rectangle: isBalanced,
            smallTitle: true,
            strokedTitle: true,
            picture: {
              placeholder: true,
              maxSize: 960,
              lazy: true,
              crop: isBalanced ? {
                width: 16,
                height: 10,
              } : {
                width: 1,
                height: 1,
              },
              sizes: isBalanced ?
                '(min-width: 1920px) 425px, (min-width: 1200px) 22vw, (min-width: 720px) 50vw, 50vw' :
                '(min-width: 1920px) 300px, (min-width: 1200px) 15vw, (min-width: 720px) 30vw, 50vw',
            },
            entries: related,
            Wrapper: GridListEntry,
          })}
        </GridList>
      </div>
    </SiteContentEntry>
  )
}

export default ArticleRelated
